// ============================================================================
// dataTypes/liveStreamManagment/sourceRegistry/acquirers/SceneAcquirer.ts
// Gère les sources de type 'scene' (composition canvas).
//
// Comme RemoteAcquirer, le stream n'est pas acquis par l'acquirer.
// C'est le ScenePipeline qui produit le stream et l'injecte via
// registry.injectStream(). Ce fichier sera complété à l'étape 5.
// ============================================================================

import { Source, SourceAcquirer } from '../types';

export class SceneAcquirer implements SourceAcquirer {

  async acquire(source: Source): Promise<MediaStream> {
    // Le stream d'une scène est produit par le ScenePipeline
    // et injecté via registry.injectStream().
    if (source.stream) {
      return source.stream;
    }
    throw new Error(
      `[SceneAcquirer] Le stream pour la scène "${source.id}" n'a pas été injecté. ` +
      `Le ScenePipeline doit appeler registry.injectStream() d'abord.`
    );
  }

  release(_source: Source): void {
    // Le ScenePipeline gère la destruction du canvas et du stream.
    // Rien à faire ici.
  }
}
